export const AUTH_HEADER = (token: string) => ({
  Authorization: `Bearer ${token}`,
})

export const TIMEZONE_HEADER = (timezone: string) => ({
  timezone,
})
export const LANGUAGE_HEADER = (language: string | 'ar' | 'en') => ({
  'X-localization': language,
})